import React from 'react';

import './FlexRowFillers.scss';

function FlexRowFillers({ hasFillers, className = '' }) {
  if (!hasFillers) {
    return null;
  }

  // Set the default number of fillers to 3
  const fillerCount = typeof hasFillers === 'number' ? hasFillers : 3;

  return (
    <>
      {Array.from({ length: fillerCount }, (_, index) => (
        <span key={index} className={`${className} mn_flexRowFiller`} />
      ))}
    </>
  );
}

export default FlexRowFillers;
